<template>
<div class="sponsor-container">
  <div class="row">
    <div class="col-1"></div>
    <div class="col-xl-2 col-sm-12" v-for="(sponsor,idx) in sponsors">
      <Sponsor :sponsor="sponsor"></Sponsor>
    </div>
  </div>
</div>
</template>

<script>
  import Sponsor from "./Sponsor";
  export default {
    name: "SponsorContainer",
    components: {Sponsor},
    data() {
      return {
        sponsors: [
          {
            title: 'DPS Calculator for Old School Runescape by Bitterkoekje',
            link: 'https://docs.google.com/spreadsheets/d/1wzy1VxNWEAAc0FQyDAdpiFggAfn5U6RGPp2CisAHZW8/edit?usp=sharing',
            icon: '/static/images/icons/sponsors/google_sheets.png',
          },
          {
            title: 'OSRSBox',
            link: 'https://www.osrsbox.com/',
            icon: '/static/images/icons/sponsors/osrsbox.png',
          },
          {
            title: 'Runelite',
            link: 'https://runelite.net/',
            icon: '/static/images/icons/sponsors/runelite.png',
          },
          {
            title: 'OSRS Wiki',
            link: 'https://oldschool.runescape.wiki/',
            icon: '/static/images/icons/sponsors/osrswiki.png',
          },
          {
            title: 'Old School Runescape',
            link: 'https://oldschool.runescape.com/',
            icon: '/static/images/icons/sponsors/osrs.png',
          }
        ]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SponsorContainer.vue